import { ViewFilterName } from '../../../enum/types/ViewFilterName';

export const renaissanceRatingControlsDetailsList = [
  ViewFilterName._RatingFundamentals,
  ViewFilterName._RatingCorpGov,
  ViewFilterName._RatingValuation,
  ViewFilterName._RatingTechnicals,
];
